// extracted by mini-css-extract-plugin
export default {"skeleton-progress":"Xh8aL"};